import { createContext, useContext, type ReactNode } from "react"

export type CompanyCapabilities = {
  manageCompany: boolean
  manageTeam: boolean
  manageJobLifecycle: boolean
  manageHackathons: boolean
  manageEmployerCheckout: boolean
  recruit: boolean
}

type CompanyCapabilityState = CompanyCapabilities | null | undefined

const CompanyCapabilitiesContext = createContext<CompanyCapabilityState>(undefined)

export function CompanyCapabilitiesProvider({
  value,
  children,
}: {
  value: CompanyCapabilityState
  children: ReactNode
}) {
  return (
    <CompanyCapabilitiesContext.Provider value={value}>
      {children}
    </CompanyCapabilitiesContext.Provider>
  )
}

/** Reactive server-derived UI hints only; every Convex endpoint still authorizes itself. */
export function useCompanyCapabilities() {
  return useContext(CompanyCapabilitiesContext)
}
